import React, { createContext, useState, useContext, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";


const SnackbarContext = createContext();

// Hook to use snackbar in any component
export const useSnackbar = () => useContext(SnackbarContext);

// Provider that holds the snackbar state and showSnackbar function
export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "success" });
  const location = useLocation(); // Get current route


  // Function to show snackbar
  const showSnackbar = useCallback((msg, severity = "success") => {
    setSnackbar({ open: true, message: msg, type: severity });
     // Scroll to top when a snackbar message appears
    //  window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      setSnackbar((prev) => ({ ...prev, open: false, message: "" })); // Reset message too
    }, 2000);
  }, []);



  // Close snackbar when the route changes
  useEffect(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, [location.pathname]);

  return (
    <SnackbarContext.Provider value={{ showSnackbar, snackbar }}>
      {children}
      {/* 
        You can either render the Snackbar here (with fixed placement) 
        or leave it out so that consumers can render it where they wish.
      */}
    </SnackbarContext.Provider>
  );
};

// Export a separate Snackbar UI component.
// It uses no fixed positioning—so you can place it wherever you need.
export const SnackbarUI = ({ message, type }) => {
  if (!message) return null;
  return (
    <div  key={message} className={`alert alert-${type} m-3`} role="alert">
      {message}
    </div>
  );
};
